{
    "RangeCombo_Search_Placeholder": "Suche...",
    "NAME": "RangeComboLanguage",
    "Validation_Generic_Error_Message": "Es wurden aktuell ein oder mehrere Fehler festgestellt.",
    "Validation_Generic_Error_Max_Entries": "Sie haben die maximale Anzahl an Einträgen erreicht\/überschritten.",
    "RangeCombo_Search_More_Options_Message": "Weitere Optionen suchen"
}